<script setup lang="ts">
    const model = defineModel<number | string>();

    defineProps<{
        id: string;
        name: string;
        value: number | string;
        disabled?: boolean;
        label: string;
    }>();
</script>
<template>
    <label
        class="text-body flex gap-1.5 items-center"
        :class="[
            disabled ? 'pointer-events-none' : 'cursor-pointer',
            model === value ? 'font-semibold' : '',
        ]"
    >
        <input
            :id="id"
            v-model="model"
            class="Custom-radio"
            type="radio"
            :name="name"
            :value="value"
            :disabled="disabled"
        />

        {{ label }}
    </label>
</template>
